import { FormattedMessage } from 'react-intl';

import { CollapsibleListSection } from 'ui-components/components/collapsible-list/collapsible-list-section';
import { CollapsibleListSectionHeader } from 'ui-components/components/collapsible-list/collapsible-list-section-header';
import { CollapsibleListSectionContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content';
import { noop } from 'ui-components/default-props/noop';

import { DisplaySummaryMessage } from './display-summary-message';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import { getSummarySectionSummary } from './get-summary-section-summary';
import { OrderSummary } from '../../../edit-and-read-only-order-summary/order-summary';
import { PremiumProgramTags } from '../../../premium-programs/premium-program-tags';
import { useEnablePremiumProgramTags } from '../../../../feature-flags/hooks/use-enable-premium-program-tags';
import { useSellerFormattedDate } from '../../../../hooks/use-datetime-formats';

import { messages } from './messages';

import style from './summary.module.css';

/**
 * @param {object} props
 * @param {object} [props.amountSummary]
 * @param {object[]} [props.discounts]
 * @param {object} [props.dragHandleProps]
 * @param {string[]} [props.fulfillmentPlanIds]
 * @param {string} [props.holdUntilDateTime]
 * @param {boolean} [props.open]
 * @param {(open: boolean) => void} [props.onClick]
 * @param {string} [props.orderDateTime]
 * @param {string} [props.paidDateTime]
 * @param {object[]} [props.salesOrders]
 * @param {string} [props.shipByDateTime]
 * @param {string[]} [props.premiumPrograms]
 * @returns {JSX.Element}
 */
export const Summary = ({
  amountSummary = emptyObject,
  discounts = emptyArray,
  dragHandleProps,
  fulfillmentPlanIds = emptyArray,
  holdUntilDateTime = '',
  open = false,
  onClick = noop,
  orderDateTime = '',
  paidDateTime = '',
  salesOrders = emptyArray,
  shipByDateTime = '',
  premiumPrograms = emptyArray,
}) => {
  const userFriendlyOrderDate = useSellerFormattedDate(orderDateTime);
  const isPremiumProgramTagsEnabled = useEnablePremiumProgramTags();

  return (
    <CollapsibleListSection open={open}>
      <CollapsibleListSectionHeader
        dragHandleProps={dragHandleProps}
        onClick={() => onClick(open)}
        summaryData={getSummarySectionSummary(open, userFriendlyOrderDate, amountSummary)}
        summaryDataStyle={style['summary-extra-info']}
        theme='white'
      >
        <div className={style['summary-header']}>
          <FormattedMessage {...messages.summary} />
          {isPremiumProgramTagsEnabled && (
            <div className={style['premium-programs']}>
              <PremiumProgramTags premiumPrograms={premiumPrograms} />
            </div>
          )}
        </div>
      </CollapsibleListSectionHeader>
      <CollapsibleListSectionContent>
        <DisplaySummaryMessage className={style['summmary-message']} fulfillmentPlanIds={fulfillmentPlanIds} salesOrders={salesOrders} />
        {salesOrders.length === 1 && (
          <OrderSummary
            amountSummary={amountSummary}
            discounts={discounts}
            holdUntilDateTime={holdUntilDateTime}
            isInDrawer
            orderDateTime={orderDateTime}
            paidDateTime={paidDateTime}
            salesOrderId={salesOrders[0].salesOrderId}
            shipByDateTime={shipByDateTime}
          />
        )}
      </CollapsibleListSectionContent>
    </CollapsibleListSection>
  );
};
